module.exports = __webpack_public_path__ + "static/media/no-img.be940c4b.jpg";